import React, { useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import Page from '../../../atoms/page/Page'
import { QuestionForm } from './QuestionForm'
import API from '../../../../services/api'
import { useQuestion } from '../../../../hooks/useQuestion'

const AssessmentEditQuestion: React.FC<{}> = () => {
  const { assessmentId, questionId, groupId } = useParams<{
    assessmentId: string
    groupId: string
    questionId: string
  }>()

  const { inProgress, data: questionData } = useQuestion(assessmentId, groupId, questionId)

  const history = useHistory()

  const onSave = useCallback(async (groupId: string, payload: API.AssessmentQuestionRequest): Promise<API.AssessmentQuestionResponse> => {
    return API.updateAssessmentQuestion(assessmentId, groupId, questionId, payload)
  }, [assessmentId, questionId])

  const onComplete = useCallback(() => {
    history.push(`/assessments/${assessmentId}/view?groupId=${groupId}`)
  }, [assessmentId, history, groupId])

  if (inProgress || !questionData) {
    return null
  }

  return <Page>
    <QuestionForm
      mode='edit'
      assessmentId={assessmentId}
      onSave={onSave}
      onCancel={onComplete}
      onComplete={onComplete}
      data={questionData}
      groupId={groupId}
    />
  </Page>
}

export default AssessmentEditQuestion